import React from 'react'
import PropTypes from 'prop-types'

import Moment from 'moment'

const Item = (props) => {
  const fileName = props.row.url.split('/')
  return (<tr>
    <td>
      {
        props.indexKey + 1
      }
    </td>
    <td>
      {
        props.row.url
        ? <a href={props.row.url} rel="noopener noreferrer" target="_blank" >
          <span>{fileName[fileName.length - 1]}</span>
        </a>
        : '-'
      }
    </td>
    <td>
      {
        props.row.updatedAt
        ? Moment(`${props.row.updatedAt}`).format('DD MMMM YYYY')
        : '-'
      }
    </td>
    <td>
      {
        props.row.caption
        ? <span>{props.row.caption.length > 30 ? ` ${props.row.caption.substring(0, 50)}...` : props.row.caption}</span>
        : '-'
      }
    </td>
  </tr>)
}


Item.propTypes = {
  row: PropTypes.shape({
    caption: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    chat: PropTypes.shape({
      say: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
